import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { IStyle } from '../../Interface/style'
import { SsrService } from '../../services/ssr.service'
import { TracksService } from '../../services/tracks.service'

@Component({
  selector: 'bmcore-genre-categories-block',
  templateUrl: './bmcore-genre-categories-block.component.html',
  styleUrls: ['./bmcore-genre-categories-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGenreCategoriesBlockComponent implements OnInit {
  popularGenres: Array<IStyle> = []

  constructor(
    private trackService: TracksService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.ssrService.wait('bmcore-genre-categories-block: trackService.Styles')
    this.trackService.Styles.subscribe(styles => {
      this.ssrService.ready('bmcore-genre-categories-block: trackService.Styles')
      this.popularGenres = styles.filter(s => {
        return s.id === 42 || s.id === 44 || s.id === 46 || s.id === 51 || s.id === 52 || s.id === 47
      })
    })
  }
}
